<template>
  <div id="dept">
    <!-- {{PlugJson}} -->
  </div>
</template>

<script>
export default {
  name: "dept"
};
</script>

<style scoped>
</style>